<template>
    <van-overlay :show="visible" @click="visible = false">
        <div class="wrapper">
            <img :src="qrCodeBase64" alt="">
        </div>
    </van-overlay>
</template>
<script setup>
import { ref } from 'vue'
import QRCode from 'qrcode'

const props = defineProps({
    url: {
        type: String,
        default: ''
    }
})

const visible = ref(false)

const qrCodeBase64 = ref('')
defineExpose({
    show(url) {
        QRCode.toDataURL(url, {
            width: 200,
            height: 200,
            color: '#000',
            colorLight: '#fff',
        }).then(res => {
            qrCodeBase64.value = res
            visible.value = true
        })
    }
})
</script>
<style scoped lang="scss">
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    img {
        width: 200rem;
        height: 200rem;
    }
}
</style>
